export const parts_page_detail = {
  back_aria: "Back to parts inventory",
  header_part: "Part",
  edit_aria: "Edit part",
  delete_aria: "Delete part",
  get_more_info: "Get More Info",
  show_private: "Show private details",
};
